import PropTypes from 'prop-types';
import React from 'react';
import { Button, Text, Img, Icon, DatePicker } from '../../Atoms';
import { Upload, Input } from '../../Molecules';
import { DOCUMENT_UPLOAD_ACCEPT } from '../../Config/Config';
import { validateDocumentFile } from '../../Validation';
import SendDocumentErrors from './SendDocumentErrors';

const SubmitForm = ({
  selectFile,
  onChange,
  description,
  isDescriptionValid,
  isUploadValid,
  sendDocumentErrors,
  type,
  seuil,
  onSubmit
}) => {
  return (
    <div style={{ paddingBottom: '30px' }}>
      <Upload
        handleFileChange={selectFile}
        accept={DOCUMENT_UPLOAD_ACCEPT}
        validateFile={validateDocumentFile}
        errorMsg="Attention : merci de bien vouloir nous joindre votre document."
        isUploadValid={isUploadValid}
      />
      <Input
        placeholder="Laissez-nous un message qui décrit votre besoin (obligatoire)"
        className="input-decription-document"
        onChange={(e) => onChange(e)}
        as="textarea"
        value={description}
        errorMessage="Attention : merci de bien vouloir joindre un message à votre envoi."
        isInvalid={!isDescriptionValid}
      />
      <SendDocumentErrors errors={sendDocumentErrors} />
      <div className="container-btn-send-doc">
        <Button
          disabled={
            !isUploadValid ||
            !isDescriptionValid ||
            (type?.name == 'FACTURE' && seuil === 0)
          }
          text="Envoyer"
          className="btn-send-doc"
          onClick={() => onSubmit()}
          resetHover={true}
        />
      </div>
    </div>
  );
};

SubmitForm.propTypes = {
  selectFile: PropTypes.func,
  onChange: PropTypes.func,
  description: PropTypes.string,
  isDescriptionValid: PropTypes.bool,
  isUploadValid: PropTypes.bool,
  sendDocumentErrors: PropTypes.arrayOf(PropTypes.string),
  type: PropTypes.shape({
    name: PropTypes.string
  }),
  seuil: PropTypes.number,
  onSubmit: PropTypes.func
};

export default SubmitForm;
